import { FC, useContext, useState } from "react";
import NotificationDispatch, {
  showErrorNotification,
  showSuccessNotification,
} from "../../context/notificationContext";
import { useI18n } from "../../hooks/useTranslations";
import { useManufacturersApi } from "../../http/manufacturers/api";
import { UpsertManufacturer } from "../../http/manufacturers/types";
import SvgAdd from "../icons/Add";
import Button from "../ui/Button";
import ModalDialog from "../ui/ModalDialog";
import ManufacturerForm, { ManufacturerFormBody } from "./ManufacturerForm";

const CreateManufacturerButton: FC = () => {
  const i18n = useI18n();
  const [show, setShow] = useState(false);
  const dispatch = useContext(NotificationDispatch);
  const [isSubmitting, setIsSubmitting] = useState(false);
  const manufacturersApi = useManufacturersApi();

  const onSubmit = async (formData: ManufacturerFormBody) => {
    const body: UpsertManufacturer = {
      name: formData.name ?? "",
    };

    setIsSubmitting(true);
    try {
      await manufacturersApi.insertAdminManufacturer(body);
      dispatch(showSuccessNotification(i18n.t));
      setShow(false);
    } catch (err) {
      dispatch(showErrorNotification(i18n, err));
    } finally {
      setIsSubmitting(false);
    }
  };

  return (
    <>
      <Button buttonProps={{ onClick: () => setShow(true) }} glyph={SvgAdd} />
      {!!show && (
        <ModalDialog onClose={() => setShow(false)} title={i18n.t.manufacturers.new}>
          <ManufacturerForm isDisabled={isSubmitting} onSubmit={onSubmit} />
        </ModalDialog>
      )}
    </>
  );
};

export default CreateManufacturerButton;
